export interface TeamSeatRange {
  defaultCount: number;
  minCount: number;
  maxCount?: number;
}

interface TeamSeatInfoLike {
  lowerLimit?: unknown;
  lower_limit?: unknown;
  upperLimit?: unknown;
  upper_limit?: unknown;
}

const TEAM_SEAT_UNLIMITED_MAX = -1;

/** 将接口数字字段转换成非负整数，非法值交给调用方兜底。 */
function toNonNegativeInteger(value: unknown) {
  const numberValue = Number(value);
  if (!Number.isFinite(numberValue) || numberValue < 0) return undefined;
  return Math.floor(numberValue);
}

/** 将接口上限转换成前端限制，upper_limit 为 -1 统一表示不限制加购上限。 */
function normalizeTeamSeatMaxCount(value: unknown) {
  const numberValue = Number(value);
  if (numberValue === TEAM_SEAT_UNLIMITED_MAX) return undefined;
  if (!Number.isFinite(numberValue) || numberValue < 0) return 0;
  return Math.floor(numberValue);
}

/** 从接口 seat_info 生成团队席位范围，只认后端下发的 lower/upper limit 字段。 */
export function getTeamSeatRangeFromSeatInfo(seatInfo: TeamSeatInfoLike = {}): TeamSeatRange {
  const minCount = toNonNegativeInteger(seatInfo.lowerLimit ?? seatInfo.lower_limit) ?? 0;
  return {
    minCount,
    maxCount: normalizeTeamSeatMaxCount(seatInfo.upperLimit ?? seatInfo.upper_limit),
    defaultCount: minCount,
  };
}

/** 按团队席位范围裁剪数量，maxCount 缺省代表不限制加购上限。 */
export function clampTeamSeatCount(
  seatRange: Pick<TeamSeatRange, 'minCount' | 'maxCount'>,
  nextCount: number,
) {
  const countWithMin = Math.max(seatRange.minCount, nextCount);
  if (seatRange.maxCount === undefined) return countWithMin;
  return Math.min(seatRange.maxCount, countWithMin);
}
